import { apiWithToken } from '../api';

const resouceUrl = '/condicionante';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  // console.log("serivce condicionante load params: ",params);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const select = async () => {

  return await api.get(`${resouceUrl}?fields=id,nome&raw_list`);
};

export const show = async (id) => {
  // return await api.get(`${resouceUrl}/${payload.id}`,{
  //   params:{
  //     ...payload.params
  //   }
  // });
  return await api.get(`${resouceUrl}/${id}`);
}

export const update = async (id, condicionante) => {
  return await api.put(`${resouceUrl}/${id}`, condicionante);
}


export const store = async (condicionante) => {
  let response = await api.post(resouceUrl , condicionante);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}
